import Blocker from './Blocker';

export default Blocker;



// WEBPACK FOOTER //
// ./src/components/Blocker/index.js